import { connect } from 'react-redux';
import TeacherTrainingVideo from '../../components/TeacherTrainingVideo';
import { selectors as CurriculumSelectors } from '../../reducers/curriculums';

const mapStateToProps = state => ({
  training: CurriculumSelectors.getCurrentSelectedTeacherTraining(state),
});

export default connect(mapStateToProps)(TeacherTrainingVideo);
